<template>
  <!-- 查看评论 -->
  <a-card :bordered="false">
    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button
        @click="checkCommentBackHandleOk('0')"
        type="primary"
        icon="samll"
        >审核通过</a-button
      >
      <a-button
        @click="checkCommentBackHandleOk('1')"
        type="primary"
        icon="small"
        >审核驳回</a-button
      >
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
        >项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>
      <a-table
        :columns="columns"
        size="small"
        :data-source="dataSources"
        :loading="loading"
        :rowSelection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange,
        }"
        rowKey="id"
        :scroll="{ x: true }"
        ref="table"
        bordered
        :pagination="ipagination"
        class="j-table-force-nowrap"
        @change="handleTableChange"
      >
        <span slot="checkFlag" slot-scope="text, record">
          <span v-if="record.checkFlag === 2">未审核</span>
          <span v-else-if="record.checkFlag === 0">审核成功</span>
          <span v-else-if="record.checkFlag === 1">审核驳回</span>
        </span>
      </a-table>
    </div>
  </a-card>
</template>

<script>
import { getAction, putAction } from '@/api/manage';
// import pick from 'lodash.pick'
import JDate from '@/components/jeecg/JDate';
// import moment from "moment";
import JMultiSelectTag from '../../../../components/dict/JMultiSelectTag';
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
export default {
  mixins: [JeecgListMixin],
  name: 'CommentBackModal',
  components: {
    JDate,
    JMultiSelectTag,
  },
  props: {},
  data() {
    return {
      loading: false,
      //评论回复表头
      columns: [
        {
          title: '发起回复用户',
          align: 'center',
          dataIndex: 'userId',
        },
        {
          title: '评论内容',
          align: 'center',
          dataIndex: 'content',
        },
        {
          title: '审核状态',
          align: 'center',
          dataIndex: 'checkFlag',
          scopedSlots: { customRender: 'checkFlag' },
        },
        {
          title: '评论时间',
          align: 'center',
          dataIndex: 'createTime',
        },
      ],
      dataSources: [],
      appId: '',
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      url: {
        list:
          process.env.VUE_APP_CMS_MARKETING + '/commentBack/commentBackList',
        check:
          process.env.VUE_APP_CMS_MARKETING + '/commentBack/changeCheckFlag',
      },
    };
  },
  created() {},
  /*watch: {
      model(newVal, oldVal) {
        this.reloadDataSource()
      }
    },*/
  methods: {
    onClearSelected() {
      this.selectedRowKeys = [];
      this.selectionRows = [];
    },
    getList(id) {
      this.appId = id;
      this.loading = true;
      // this.dataSources = [];
      getAction(this.url.list, { id: id })
        .then((res) => {
          if (res.success) {
            this.dataSources = res.result.records;
            this.ipagination.total = res.result.total;
            console.log('dataSources', this.dataSources);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 点击审核通过或审核驳回时触发
    checkCommentBackHandleOk(opt) {
      var ids = '';
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择一条记录！');
        return;
      }
      for (var a = 0; a < this.selectionRows.length; a++) {
        ids += this.selectionRows[a].id + ',';
      }
      if (ids.length <= 0) {
        this.$message.warning('请选择一条有效的记录！');
        return;
      }
      var that = this;
      this.$confirm({
        title: '审核',
        content: '确定审核' + (opt == '0' ? '通过' : '驳回') + '?',
        onOk: function () {
          that.loading = true;
          putAction(that.url.check, { ids: ids, opt: opt })
            .then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.getList(that.appId);
                that.onClearSelected();
              } else {
                that.$message.warning(res.message);
              }
            })
            .finally(() => {
              that.loading = false;
            });
        },
      });
    },
    handleCancel() {
      this.close();
    },
    //分页
    handleTableChange(pagination, filters, sorter) {
      this.onClearSelected(); //分页切换时清空表格选中
      //分页、排序、筛选变化时触发
      if (Object.keys(sorter).length > 0) {
        this.isorter.column = sorter.field;
        this.isorter.order = 'ascend' == sorter.order ? 'asc' : 'desc';
      }
      this.ipagination = pagination;
      this.loadData();
    },
  },
};
</script>
